function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

export var Slideshow = /*#__PURE__*/function () {
  function Slideshow(fancybox) {
    _classCallCheck(this, Slideshow);

    this.fancybox = fancybox;
    this.active = false;
    this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
  }

  _createClass(Slideshow, [{
    key: "isActive",
    value: function isActive() {
      return this.active;
    }
  }, {
    key: "setTimer",
    value: function setTimer() {
      var _this = this;

      if (!this.active || this.timer) {
        return;
      }

      var delay = this.fancybox.option("slideshow.delay", 3000);
      this.timer = setTimeout(function () {
        _this.timer = null;

        if (!_this.fancybox.option("infinite") && _this.fancybox.getSlide().index === _this.fancybox.Carousel.slides.length - 1) {
          _this.fancybox.jumpTo(0, {
            friction: 0
          });
        } else {
          _this.fancybox.next();
        }
      }, delay);
      var $progress = this.$progress;

      if (!$progress) {
        $progress = document.createElement("div");
        $progress.classList.add("fancybox__progress");
        this.fancybox.$carousel.parentNode.insertBefore($progress, this.fancybox.$carousel);
        this.$progress = $progress;
        $progress.offsetHeight;
        /* trigger reflow */
      }

      $progress.style.transitionDuration = "".concat(delay, "ms");
      $progress.style.transform = "scaleX(1)";
    }
  }, {
    key: "clearTimer",
    value: function clearTimer() {
      clearTimeout(this.timer);
      this.timer = null;

      if (this.$progress) {
        this.$progress.style.transitionDuration = "";
        this.$progress.style.transform = "";
        this.$progress.offsetHeight;
        /* trigger reflow */
      }
    }
  }, {
    key: "activate",
    value: function activate() {
      if (this.active) {
        return;
      }

      this.active = true;
      this.fancybox.$container.classList.add("has-slideshow");

      if (this.fancybox.getSlide().state === "done") {
        this.setTimer();
      }

      document.addEventListener("visibilitychange", this.handleVisibilityChange, false);
    }
  }, {
    key: "handleVisibilityChange",
    value: function handleVisibilityChange() {
      this.deactivate();
    }
  }, {
    key: "deactivate",
    value: function deactivate() {
      this.active = false;
      this.clearTimer();
      this.fancybox.$container.classList.remove("has-slideshow");
      document.removeEventListener("visibilitychange", this.handleVisibilityChange, false);
    }
  }, {
    key: "toggle",
    value: function toggle() {
      if (this.active) {
        this.deactivate();
      } else if (this.fancybox.Carousel.slides.length > 1) {
        this.activate();
      }
    }
  }]);

  return Slideshow;
}();